<template>
   <div class="swiper-container">
        <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
        <!-- Additional required wrapper -->
        <div class="swiper-wrapper">

            <!--SLIDE-1-->
            <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Acción problémica / pág. 1">
                <div class="container-fluid Fondo3Ppal topactivi Fondo-Actividades d-flex align-items-center">
                    <div class="container mx-auto">
                        <div class="row">
                            <div class="col-xl-7 col-lg-5 col-md-12 p-4">
                                <div>
                                    <h2 class="text-white">Acción problémica</h2>
                                    <h3 class="text-white">Ventas semestrales de automóviles y camiones</h3>
                                    <h5 class="text-white">Tipo de actividad: selección</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="container-fluid">
                    <div class="row">
                        <div class="col-12 d-none d-xl-block d-lg-block">
                            <p class="text-right mr-3 txtfiguras color1Ppal mt-2">Imagen de <span class="url"><a href="https://www.freepik.es/shurkin-son" target="_blank">@shurkin-son</a></span> en <span class="url"><a href="https://www.freepik.es/foto-gratis/mujer-joven-expresiva-posando_11199410.htm#page=3&query=estudiar&position=28" target="_blank">Freepik</a></span></p>
                        </div>
                    </div>
                </div>

                <div class="container mt-4">
                    <div class="row">
                        <div class="col-md-12">
                            <h4>¿Qué hacer?</h4>
                            <p>La actividad comprende tres numerales, cada uno de selección múltiple. Debe escogerse la respuesta correcta entre tres opciones ( A, B o C).</p>
                            <h4 class="mt-4">Planteamiento</h4>
                            <p>Un concesionario de autos ofrece en venta dos tipos de camiones, los que trabajan con diésel y los que trabajan con gasolina. Igualmente, la entidad ofrece dos tipos de automóviles, eléctricos e híbridos.</p>
                            <p>La tabla que se presenta a continuación relaciona las ventas de camiones y automóviles hechas por el concesionario durante un semestre.</p>
                            <div class="row">
                                <div class="col-lg-6 col-12">
                                    <div class="table mt-3 table-responsive">
                                        <table class="table table-borderless">
                                            <thead class="bordeTitTabla">
                                                <tr class="Fondo0Ppal">
                                                    <th scope="col" class=""><p class="mb-0 pb-0  p-2 text-center align-middle"></p></th>
                                                    <th scope="col"><p class="mb-0 pb-0 p-2 text-center align-middle">Diésel</p></th>
                                                    <th scope="col"><p class="mb-0 pb-0 p-2 text-center align-middle">10</p></th>
                                                    <th scope="col"><p class="mb-0 pb-0 p-2 text-center align-middle"></p></th>
                                                </tr>
                                            </thead>
                                            <tbody class="tablacontenido">
                                                <tr class="bg-white">
                                                    <td class="pb-0 mb-0 align-middle"> <p class="color8Ppal mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center">Gasolina</p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center">20</p> </td>
                                                    <td class="pb-0 mb-0 align-middle"> <p class="mb-0 pb-0 text-center"></p> </td>
                                                </tr>                                          
                                                <tr class="bg-white" style="border-bottom: 1px solid #661081">
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"><b>Camiones</b></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"> <p class="mb-0 pb-0 text-center">30</p> </td>
                                                </tr>
                                                <tr class="bg-white">
                                                    <td class="pb-0 mb-0 align-middle"> <p class="color8Ppal mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center">Eléctricos</p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"> <p class="mb-0 pb-0 text-center"></p> </td>
                                                </tr>
                                                <tr class="bg-white">
                                                    <td class="pb-0 mb-0 align-middle"> <p class=" mb-0 pb-0 text-center"><b>Automoviles</b></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center">Híbridos</p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"> <p class="mb-0 pb-0 text-center">150</p> </td>
                                                </tr>
                                                <tr class="">
                                                    <td class="pb-0 mb-0 align-middle"> <p class="color8Ppal mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle"><p class="mb-0 pb-0 text-center"></p> </td>
                                                    <td class="pb-0 mb-0 align-middle bg-white"> <p class="mb-0 pb-0 text-center">Total</p> </td>
                                                </tr>                          
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <p>De acuerdo con la información suministrada en la tabla, resuelva los numerales:</p>
                            
                        </div>
                    </div>
                </div> 
                
                <div class="container-fluid mb-5 pb-4">
                    <div class="row">
                        <div class="col-lg-8 col-md-12 offset-lg-2">
                            <div class="row">
                               <div class="col-xl-6 col-12">
                                   <p><b class="color3Ppal">1.</b> ¿Con respecto al total de camiones vendidos, la razón de camiones a base de gasolina es:</p>
                                   <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_1" id="checkAP_A" @click="validaRespuesta($event,1,'a')"></button>
                                            </div>
                                            <p v-katex:auto>\(\frac{1}{2}\)</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_1" id="checkAP_B" @click="validaRespuesta($event,1,'b')"></button>
                                            </div>
                                            <p v-katex:auto>\(\frac{2}{3}\)</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_1" id="checkAP_C" @click="validaRespuesta($event,1,'c')"></button>
                                            </div>
                                            <p v-katex:auto>\(\frac{2}{9}\)</p>
                                        </div>
                                    </div>
                                   
                               </div>
                               <div class="col-xl-6 col-12">
                                   <p><b class="color3Ppal">2.</b> Las ventas de automóviles eléctricos durante el semestre se encuentran en proporción a las ventas de camiones a gasolina. De acuerdo con esta información, indique, con respecto al total de automóviles vendidos, cuál es la razón de automóviles híbridos:</p>
                                   <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_2" id="checkAP_A" @click="validaRespuesta($event,2,'a')"></button>
                                            </div>
                                            <p v-katex:auto>\(\frac{2}{3}\)</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_2" id="checkAP_B" @click="validaRespuesta($event,2,'b')"></button>
                                            </div>
                                            <p v-katex:auto>\(\frac{5}{18}\)</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_2" id="checkAP_C" @click="validaRespuesta($event,2,'c')"></button>
                                            </div>
                                            <p v-katex:auto>\(\frac{1}{3}\)</p>
                                        </div>
                                    </div>
                               </div>
                            </div>
                            <div class="row">
                               <div class="col-xl-6 col-12">
                                   <p><b class="color3Ppal">3.</b> ¿Qué porcentaje del total de las ventas semestrales (entre camiones y automóviles) representa los camiones a diésel vendidos?</p>
                                   <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_3" id="checkAP_A" @click="validaRespuesta($event,3,'a')"></button>
                                            </div>
                                            <p>20 %</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_3" id="checkAP_B" @click="validaRespuesta($event,3,'b')"></button>
                                            </div>
                                            <p>8.3 %</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 d-flex">
                                            <div>
                                                <button class="Radiobutton checkAP mr-2 checkAP_3" id="checkAP_C" @click="validaRespuesta($event,3,'c')"></button>
                                            </div>
                                            <p>5.5 %</p>
                                        </div>
                                    </div>
                                   
                               </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div v-if="faltantes" class="alert alert-danger text-center" role="alert">
                                        ¡Debe terminar toda la actividad!
                                    </div>
                                    <button class="d-flex mx-auto BtnPrincipal" @click="comprobarRespuestas()">Comprobar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--SLIDE-1-->
        </div>
        <Modales :tituloResultado="tituloResultado" :descripcionResultado="descripcionResultado" :imgURL="imgURL"/>
    </div>
</template>

<script>

import {
    SwiperController
} from '../assets/RecursosITM/js/Swiper'

import Modales from '@/components/Modales'

export default {
    name: 'AccionProblemica',
        data() {
        return {
            respuestasEstablecidasAP: ['B','C','C'],
            respuestasDadasAP: [],

            faltantes: false,
            acertadas: 0,

            tituloResultado: '',
            descripcionResultado: '',
            imgURL: ''
        }
    },
    methods: {
        validaRespuesta: function(event,numPregunta,respuesta){

            let opcionElegida = event.target.id.split("_")[1];
            let elementosGrupo=document.querySelectorAll(".checkAP_"+numPregunta);

            elementosGrupo.forEach(element => {
                element.classList.remove("active", "i-check");
            });
            event.target.classList.add("active", "i-check");

            this.respuestasDadasAP.push(opcionElegida);

            switch(numPregunta){
                case 1:            
                if(respuesta == 'b'){
                    this.$root.$emit("bv::show::modal","modal-modalAPcorrecta1");
                }else{
                    this.$root.$emit("bv::show::modal","modal-incorrectaAP");
                }
            break;
            case 2:            
                if(respuesta == 'c'){
                   this.$root.$emit("bv::show::modal","modal-modalAPcorrecta2");
                }else{
                    this.$root.$emit("bv::show::modal","modal-incorrectaAP");
                }
            break;
            case 3:            
                if(respuesta == 'c'){
                    this.$root.$emit("bv::show::modal","modal-modalAPcorrecta3");
                }else{
                    this.$root.$emit("bv::show::modal","modal-incorrectaAP");
                }
            break;
            }
        },
        
        comprobarRespuestas: function(){

            this.faltantes=false;
            this.acertadas=0;


            //Evaluando faltantes punto
            if(this.respuestasDadasAP.length < 1){
                this.faltantes=true;
                return;
            }

            for(let i=0; i < this.respuestasEstablecidasAP.length; i++){
                if(this.respuestasEstablecidasAP[i] == this.respuestasDadasAP[i]){
                this.acertadas++;
                }
            }

            if(this.acertadas >= 2){
               this.imgURL = 'recursos/img/Correcto.png'
               this.tituloResultado= '¡Muy bien!'
               this.descripcionResultado='<p>Ha logrado resolver situaciones problemas haciendo uso de los conceptos de razón y proporción y de sus propiedades.</p>';
            }else{
               this.imgURL = 'recursos/img/Incorrecto.png'
               this.tituloResultado= '¡Intente de nuevo!'
               this.descripcionResultado="<p>Usted puede mejorar su resultado al resolver situaciones problemas haciendo uso de los conceptos de razón y proporción y de sus propiedades.</p>";
            }

            //Mostramos modal
            this.$root.$emit("bv::show::modal","modal-resultadosActividades");
        },

        
        
    },
        
    components:{
        Modales
    },
      mounted() {
        SwiperController(),
        document.title = this.$route.meta.title
    }
}
</script>